import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import KrhoverSpecKeyresult from './components/okr/okr_sub_components/kr.hover.Spec_Key_result';
import { useOnClickOutside } from './hooks/useOnClickOutside';


const isValidJSON = obj => {
  try {
    JSON.parse(obj);
    return true;
  } catch (e) {
    return false;
  }
};

function KrCalPopUp(props) {
  const {showCalpopup, data, metricId, isHeadmap, isheader, refSrc = 'HEATMAP_PAGE'} = props;
  // track click status to prevent from reopening on 'closing' click on initial button
  const clickStatus = useRef(false);
  const [showPopup, setShowPopup] = useState(!clickStatus.current && showCalpopup);
  const [krCalculationHover] = useOnClickOutside(() => {
    clickStatus.current = true
    const mouseUp = () => {
      document.removeEventListener('mouseup', mouseUp);
      setTimeout(() => {
        clickStatus.current = false
      }, 100)
    }
    document.addEventListener('mouseup', mouseUp);

    setShowPopup(false);
  }, showPopup);

  useEffect(() => {
    setShowPopup(!clickStatus.current)
  }, [props]);

  return (
    <div style={{ position: 'absolute' }} ref={krCalculationHover}>
      <KrhoverSpecKeyresult
        data={data}
        showCalpopup={showPopup}
        setShowCalpopup={setShowPopup}
        isHeadmap={isHeadmap}
        isheader={isheader}
        krCalEventParams={{
          refSrc,
          'kr-id': metricId,
        }}
        />
    </div>
  )
}

const initCalkrPopup = (initialData, renderDivId, showCalpopup, metricId, isHeadmap, isheader, refSrc) => {
  if (isValidJSON(initialData)) {
    initialData = JSON.parse(initialData);
  }

  ReactDOM.render(
    <KrCalPopUp
      isHeadmap={isHeadmap}
      data={initialData}
      showCalpopup={showCalpopup}
      metricId={metricId}
      isheader={isheader}
      refSrc={refSrc}
    />,
    document.getElementById(renderDivId),
  );
};

window.initCalkrPopup = initCalkrPopup;
